import axiosInstance from '../main/axios';
import { toastr } from 'react-redux-toastr';

// const INITIAL_VALUES = {}

export function getList(contid) {
  const request = axiosInstance.get(`/fases/${contid}`);

  return {
    type: 'FASE_FETCHED',
    payload: request,
  };
}

export function getControladorFase() {
  const request = axiosInstance.get(`/fases/mapa/geral`);

  return {
    type: `FASE_FETCHED`,
    payload: request,
  };
}

export function getControladorCoresGT(contId) {
  const request = axiosInstance.get(`/fasesgeral/mapagt/${contId}`);

  return {
    type: `FASEMAP_FETCHED`,
    payload: request,
  };
}

export function getControladorCoresGF(grupoId) {
  const gid = +grupoId;
  const request = axiosInstance.get(`/fasesgeral/mapagf/${gid}`);

  return {
    type: `FASEMAP_FETCHED`,
    payload: request,
    meta: { grupo: gid, replace: true, source: 'http' },
  };
}

/** `grupos` aceita um id ou lista (modo "todos os grupos"). */
export function clearMapaFase(grupos) {
  return {
    type: 'FASEMAP_CLEAR',
    meta: { grupos },
  };
}

/**
 * Marca se o mapa está em leitura ao vivo. Com `false` o reducer descarta
 * FASEMAP_FETCHED/FASEMAP_PATCH — inclusive de requisição HTTP ou warm-up de
 * socket que já estava em vôo quando o operador pausou.
 */
export function setMapaFaseLive(ativo) {
  return {
    type: 'FASEMAP_LIVE',
    meta: { ativo: !!ativo },
  };
}

export function getInicioMapa(grupo) {
  const request = axiosInstance.get(`/fasesgeral/mapa/inicio/${+grupo}`);

  return {
    type: `FASEMAPAINICIO_FETCHED`,
    payload: request,
  };
}

export function getPluviometroMapaData(grupoId) {
  const request = axiosInstance.get(`/pluviometro/mapa/${grupoId || ''}`);

  return {
    type: `PLUVIOMETRO_MAPA_FETCHED`,
    payload: request,
  };
}

/** Fase 3/4 — atualiza redux com payload do socket (sem HTTP). */
export function setMapaFaseFromSocket({ data, full = true, controladorId = null, grupoId = null, authoritative = false }) {
  const meta = (grupoId !== null && grupoId !== undefined) ? { grupo: +grupoId } : {};
  if (full) {
    return {
      type: 'FASEMAP_FETCHED',
      payload: { data },
      meta: { ...meta, authoritative: !!authoritative },
    };
  }
  return {
    type: 'FASEMAP_PATCH',
    payload: { data, controladorId },
    meta,
  };
}

export function update(values) {
  const method = values && values.id ? 'put' : 'post';
  return submit(values, method);
}

function submit(values, method) {
  return dispatch => {
    const id = values.id ? values.id : '';
    const controlador_id = values.controlador_id;
    const url = method === 'post' ? `/fases/${controlador_id}` : `/fases/${controlador_id}/${id}`;

    axiosInstance[method](url, values)
      .then(resp => {
        toastr.success('Sucesso', 'Operação Realizada com sucesso.');
      })
      .catch(e => {
        try {
          const errs = (e && e.response && e.response.data && e.response.data.errors) || ['Erro desconhecido'];
          errs.forEach(error => toastr.error('Erro', error));
        } catch (err) {
          toastr.error('Erro', 'Falha ao salvar');
        }
      });
  };
}

export function init() {
  return [getList()];
}
